<script>
    import {_} from '../lib/i18n';
    export let analyze;
    export let analyzeInProgress;

    let isLoading = false;
    async function restartAnalyze() {
        try {
            const result = await analyze.restart();
            if (result) {
                const updatedAnalyze = analyze;
                updatedAnalyze.handler.message = '';
                analyze= updatedAnalyze;
            }
        } catch (err) {
            console.error(err);
        }
    }
</script>

<section class="private-acc-block system-info system-info_red" id="private-unknown">
    <div class="private-acc-block__title-wrapper system-info__title-wrapper">
        <div class="private-acc-block__title-icon system-info__title-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="10.0001" cy="14.1668" rx="0.833333" ry="0.833333" fill="#C93329"></ellipse>
                <path d="M10 8.3335L10 11.6668" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M3.11396 14.6057L8.21123 4.4112C8.94828 2.93711 11.0519 2.93711 11.7889 4.4112L16.8862 14.6057C17.5511 15.9355 16.5841 17.5002 15.0973 17.5002H4.90282C3.41605 17.5002 2.44906 15.9355 3.11396 14.6057Z" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </div>
        <h3 class="private-acc-block__title-text system-info__title-text">{$_('restartRequiredAlert.title')}</h3>
    </div>
    <p class="private-acc-block__text system-info__text">
        {@html $_('restartRequiredAlert.description')}
    </p>

    <div class="private-acc-block__controls-wrapper system-info__controls-wrapper">
        <a href="https://instagram.com" target="_blank" class="button button_ghost system-info__controls-btn system-info__controls-btn_main private-acc-block__btn">
            {$_('restartRequiredAlert.goToInstagram')}
        </a>
        <div class="button button_ghost system-info__controls-btn system-info__controls-btn_main private-acc-block__btn" on:click={restartAnalyze}>
            {$_('restartRequiredAlert.startAnalyze')}
        </div>
    </div>
</section>